function CostSnapshotFactory() {
  class CostSnapshot {
    constructor(data) {
      if (data) this.setData(data);
    }

    setData(data) {
      angular.extend(this, data);
    }

    setDataFromCost(costData) {
      this.name = costData.name;
      this.unit = costData.unit;
      this.price = costData.price;
      this.currency = costData.currency;
      this.comments = costData.comments;
      this.amount = costData.amount || 1;
      this.from = costData._id;
    }

    existsOnLibrary() {
      return Boolean(this.from);
    }
  }

  return CostSnapshot;
}

export default CostSnapshotFactory;
